<template>
  <div class="auth-container">
    <div class="auth-card">
      <div class="auth-header">
        <h2>{{ $t('auth.resetPassword') }}</h2>
        <p>{{ $t('auth.resetPasswordSubtitle') }}</p>
      </div>
      
      <el-form
        ref="resetForm"
        :model="resetForm"
        :rules="resetFormRules"
        label-width="100px"
        class="auth-form"
      >
        <el-form-item :label="$t('auth.newPassword')" prop="password">
          <el-input
            v-model="resetForm.password"
            type="password"
            :placeholder="$t('auth.enterNewPassword')"
            prefix-icon="el-icon-lock"
            show-password
          ></el-input>
        </el-form-item>
        
        <el-form-item :label="$t('auth.confirmPassword')" prop="confirmPassword">
          <el-input
            v-model="resetForm.confirmPassword"
            type="password"
            :placeholder="$t('auth.confirmNewPassword')"
            prefix-icon="el-icon-lock"
            show-password
          ></el-input>
        </el-form-item>
        
        <el-form-item class="auth-actions">
          <el-button type="primary" @click="handleResetPassword" :loading="loading">
            {{ $t('auth.resetPassword') }}
          </el-button>
          <el-button @click="handleBack">
            {{ $t('auth.backToLogin') }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { resetPassword, validateResetToken } from '@/apis/auth/auth.js'

export default {
  name: 'ResetPassword',
  data() {
    return {
      resetForm: {
        password: '',
        confirmPassword: ''
      },
      resetFormRules: {
        password: [
          { required: true, message: this.$t('auth.newPasswordRequired'), trigger: 'blur' },
          { min: 6, max: 20, message: this.$t('auth.passwordLength'), trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: this.$t('auth.confirmPasswordRequired'), trigger: 'blur' },
          { validator: this.validateConfirmPassword, trigger: 'blur' }
        ]
      },
      loading: false,
      token: '',
      tokenValid: false
    }
  },
  mounted() {
    // 从URL获取重置令牌
    this.token = this.$route.query.token
    
    if (!this.token) {
      this.$message.error(this.$t('auth.invalidResetLink'))
      this.tokenValid = false
      return
    }
    
    // 验证重置令牌
    this.validateToken()
  },
  methods: {
    // 验证确认密码
    validateConfirmPassword(rule, value, callback) {
      if (value !== this.resetForm.password) {
        callback(new Error(this.$t('auth.passwordNotMatch')))
      } else {
        callback()
      }
    },
    
    // 验证重置令牌
    async validateToken() {
      try {
        const response = await validateResetToken({ token: this.token })
        
        if (response.success) {
          this.tokenValid = true
        } else {
          this.tokenValid = false
          this.$message.error(this.$t('auth.invalidResetToken'))
        }
      } catch (error) {
        this.tokenValid = false
        this.$message.error(this.$t('auth.validateTokenError'))
        console.error('验证重置令牌失败:', error)
      }
    },
    
    // 提交密码重置请求
    handleResetPassword() {
      if (!this.tokenValid) {
        this.$message.error(this.$t('auth.invalidResetToken'))
        return
      }
      
      this.$refs.resetForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          
          try {
            const resetData = {
              token: this.token,
              password: this.resetForm.password
            }
            
            const response = await resetPassword(resetData)
            
            if (response.success) {
              this.$message.success(this.$t('auth.resetPasswordSuccess'))
              // 重置成功后跳转到登录页面
              this.$router.push('/login')
            } else {
              this.$message.error(response.message || this.$t('auth.resetPasswordError'))
            }
          } catch (error) {
            this.$message.error(this.$t('auth.resetPasswordError'))
            console.error('重置密码失败:', error)
          } finally {
            this.loading = false
          }
        }
      })
    },
    
    // 返回登录页面
    handleBack() {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.auth-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f7fa;
  padding: 20px;
}

.auth-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 30px;
  width: 100%;
  max-width: 480px;
}

.auth-header {
  text-align: center;
  margin-bottom: 30px;
}

.auth-header h2 {
  margin: 0 0 10px 0;
  color: #303133;
  font-size: 24px;
}

.auth-header p {
  margin: 0;
  color: #606266;
  font-size: 14px;
}

.auth-form {
  margin-bottom: 20px;
}

.auth-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.auth-actions .el-button {
  width: 120px;
}

.captcha-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.captcha-img {
  height: 36px;
  border-radius: 4px;
  cursor: pointer;
}
</style>